<template>
  <BaseField :element="element" :model="internalModel">
    <template v-slot:default="{ errors }">
      <v-text-field
        v-model.trim="internalModel"
        type="email"
        :name="field.id"
        :label="fieldLabel"
        :hint="field.hint"
        :persistent-hint="field.persistentHint"
        :placeholder="field.placeholder"
        :disabled="field.disabled"
        :readonly="field.readonly"
        :required="field.required"
        :error="errors.length > 0"
        :error-messages="errors"
        :outlined="!field.readonly"
        @focus="$event.target.select()"
        :append-outer-icon="rightIcon()"
        @click:append-outer="onClickRightIcon"
      ></v-text-field>
    </template>
  </BaseField>
</template>

<script>
import BaseField from "@/components/form/fields/BaseField";
import Component from "vue-class-component";

@Component()
export default class EmailField extends BaseField {
  get fieldStep() {
    return this.field.step ?? 1;
  }

  rightIcon() {
    return this.field?.rightIcon ? this.field?.rightIcon : null;
  }

  onClickRightIcon() {
    if (this.isDisabled() || this.isReadonly()) {
      return;
    }
    if (typeof this.field?.onClickRightIcon === "function") {
      this.field.onClickRightIcon(this.internalModel, this.field);
    }
  }
}
</script>